<template>
  <v-container>
    <br>
    <br>
    <v-row no-gutters >
      <!-- <v-col
        cols="12"
        sm="6"
      >
        <v-card
          class="mx-auto"
          max-width="300px"
          to="/demandas/create"
          flat
        >
          <v-img
            src="@/assets/img/demandas_familiares.jpeg"
            height="300px"
          ></v-img> -->

          <!--<v-card-text class="text-center">
            <h3>Presentación de Demandas Familiares</h3>
          </v-card-text>-->

        <!-- </v-card>
      </v-col> -->

      <v-col
        cols="12"
      >
      <v-card
        class="mx-auto"
        max-width="300px"
        to="/promociones/firma"
        flat
      >
        <v-img
          src="@/assets/img/promociones.jpeg"
          height="300px"
        ></v-img>

        <!--<v-card-text class="text-center">
          <h3>Presentación de Promociones</h3>
        </v-card-text>-->

      </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";

  export default {
    data(){
      return {

      }
    },
    computed: {
      ...mapGetters([
        "roleUser", "currentUser"
      ])
    },
    mounted(){

    },
    methods:{

    }
  }
</script>
